import { driverPush, updateDriverUser, updateDriverNum, selectAllDriver, insertDriver, updateDriver, deleteDriver, batchTransferDriver, uploadDriver } from "../../api/config/modules/DriverFile";

const state = {
    selectAllDriver: {},
    insertDriver: {},
    updateDriver: {},
    deleteDriver: {},
    batchTransferDriver: {},
    uploadDriver: {},
    updateDriverNum: {},
    updateDriverUser: {},
    driverPush: {}
};

const mutations = {
    SET_SELECTALLDRIVER: (state, selectAllDriver) => {
        state.selectAllDriver = selectAllDriver;
    },
    SET_INSERTDRIVER: (state, insertDriver) => {
        state.insertDriver = insertDriver;
    },
    SET_UPDATEDRIVER: (state, updateDriver) => {
        state.updateDriver = updateDriver;
    },
    SET_DELETEDRIVER: (state, deleteDriver) => {
        state.deleteDriver = deleteDriver;
    },
    SET_BATCHDRIVER: (state, batchTransferDriver) => {
        state.batchTransferDriver = batchTransferDriver;
    },
    SET_UPLOADDRIVER: (state, uploadDriver) => {
        state.uploadDriver = uploadDriver;
    },
    SET_UPDATEDRIVERNUM: (state, updateDriverNum) => {
        state.updateDriverNum = updateDriverNum;
    },
    SET_UPDATEDRIVERUSER: (state, updateDriverUser) => {
        state.updateDriverUser = updateDriverUser;
    },
    SET_DRIVERPUSH: (state, driverPush) => {
        state.driverPush = driverPush;
    },
};

const actions = {
    GET_SELECTALLDRIVER: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectAllDriver(data)
                .then((res) => {
                    commit("SET_SELECTALLDRIVER", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INSERTDRIVER: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertDriver(data)
                .then((res) => {
                    commit("SET_INSERTDRIVER", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATEDRIVER: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateDriver(data)
                .then((res) => {
                    commit("SET_UPDATEDRIVER", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETEDRIVER: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteDriver(data)
                .then((res) => {
                    commit("SET_DELETEDRIVER", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_BATCHDRIVER: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            batchTransferDriver(data)
                .then((res) => {
                    commit("SET_BATCHDRIVER", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPLOADDRIVER: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            uploadDriver(data)
                .then((res) => {
                    commit("SET_UPLOADDRIVER", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATEDRIVERNUM: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateDriverNum(data)
                .then((res) => {
                    commit("SET_UPDATEDRIVERNUM", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATEDRIVERUSER: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateDriverUser(data)
                .then((res) => {
                    commit("SET_UPDATEDRIVERUSER", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DRIVERPUSH: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            driverPush(data)
                .then((res) => {
                    commit("SET_DRIVERPUSH", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
